import { useDynamicEntityStoreContext } from '../contexts';

export default function GlobalStateModal({ id = 'globalStateJsonModal', title = 'Global State' }) {
  const state = useDynamicEntityStoreContext((state) => state);

  return (
    <div className="modal modal-xl fade" id={id} tabIndex={-1} aria-labelledby={`${id}-label`} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id={`${id}-label`}>
              {title}
            </h1>
            <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" aria-label="Close">
              <i className="fe fe-x" />
            </button>
          </div>
          <div className="modal-body">
            <pre className="overflow-y-scroll" style={{ height: '65vh' }}>
              {JSON.stringify(state, null, 4)}
            </pre>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
